"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableMenuIsDeprecated_1 = require("../../../../../../../../shared/components/table_menus/TableMenuIsDeprecated");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var AffilateBrandsList = /** @class */ (function (_super) {
    __extends(AffilateBrandsList, _super);
    function AffilateBrandsList(props) {
        return _super.call(this, props) || this;
    }
    AffilateBrandsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key);
        });
    };
    AffilateBrandsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    AffilateBrandsList.prototype.doDeprecateAction = function (key, title, deprecate) {
        this.props.data.DoSetIsDeprecated(key, deprecate, function () {
            if (deprecate) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0411\u0440\u0435\u043D\u0434 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0441\u043A\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B ",
                    React.createElement("b", null,
                        "[",
                        title,
                        "]"),
                    " \u043E\u0442\u043C\u0435\u0447\u0435\u043D \u043A\u0430\u043A \u0443\u0441\u0442\u0430\u0440\u0435\u0432\u0448\u0438\u0439"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0411\u0440\u0435\u043D\u0434 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0441\u043A\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B ",
                    React.createElement("b", null,
                        "[",
                        title,
                        "]"),
                    " \u043E\u0442\u043C\u0435\u0447\u0435\u043D \u043A\u0430\u043A \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0439"));
            }
        });
    };
    AffilateBrandsList.prototype.getLevelsArray = function () {
        var _ret = [];
        for (var i = 1; i <= 10; i++) {
            _ret.push(React.createElement(antd_1.Menu.Divider, { key: i + 100 }));
            _ret.push(React.createElement(antd_1.Menu.Item, { key: "" + i },
                React.createElement(FontAwesome_1.FA, { icon: "level-down-alt", left: true }),
                "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C ",
                i,
                " \u043D\u043E\u043C\u0435\u0440 "));
        }
        return _ret;
    };
    AffilateBrandsList.prototype.getMoreActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doMorection(e, record); } }, this.getLevelsArray()));
    };
    AffilateBrandsList.prototype.doMorection = function (e, record) {
        var _this = this;
        var _level = 1;
        _level = parseInt(e.key, 10);
        this.props.data.doSetOrderNumber(record.key, _level, function () {
            _this.props.data.LoadData(record.brand_id, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442 \u0434\u043B\u044F \u0431\u0440\u0435\u043D\u0434\u0430 \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
            });
        });
    };
    AffilateBrandsList.prototype.getColumns = function () {
        var _this = this;
        return ([{
                title: 'Бренд',
                dataIndex: this.props.data.dk_brand_title,
                key: this.props.data.dk_brand_title,
                width: 150,
            }, {
                title: 'Аффилейт',
                dataIndex: this.props.data.dk_affilate_title,
                key: this.props.data.dk_affilate_title,
                width: 150,
            }, {
                title: 'Номер п/п',
                dataIndex: this.props.data.dk_order_number,
                key: this.props.data.dk_order_number,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(antd_1.Dropdown, { overlay: _this.getMoreActionsDropDownMenu(record), trigger: ['click'] },
                        React.createElement(antd_1.Button, { style: { width: 120, minWidth: 120, maxWidth: 120 } },
                            "\u041D\u043E\u043C\u0435\u0440 ",
                            record.order_number,
                            " ",
                            React.createElement(antd_1.Icon, { type: "down" }))));
                },
                width: 130,
            }, {
                title: 'Добавлена',
                dataIndex: this.props.data.dk_date_added2,
                key: this.props.data.dk_date_added2,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added2.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Изменена',
                dataIndex: this.props.data.dk_date_changed2,
                key: this.props.data.dk_date_changed2,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_changed2.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Устаревший',
                dataIndex: this.props.data.dk_is_deprecated,
                key: this.props.data.dk_is_deprecated,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsDeprecated_1.default, { deprecatedTexts: { menu: "Пометить как устаревший", text: "Да" }, notDeprecatedTexts: { menu: "Пометить как актуальный", text: "Нет" }, record: { key: record.key, title: record.brand_title, deprecated: record.is_deprecated }, onDeprecateClick: _this.doDeprecateAction.bind(_this) }));
                },
                width: 120,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeletePlayerClick(record); } }))); },
                width: 80
            }
        ]);
    };
    AffilateBrandsList.prototype.onEditDataClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    AffilateBrandsList.prototype.onDeletePlayerClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0411\u0440\u0435\u043D\u0434 ",
                React.createElement("b", null,
                    "[",
                    record.brand_title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    AffilateBrandsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.rootRecord.key);
        }
        if (action === "create") {
            if (this.props.onCreateClick) {
                this.props.onCreateClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    AffilateBrandsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { bordered: true, columns: this.getColumns(), dataSource: this.state.data, locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, pagination: {
                    pageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return React.createElement("div", { style: { margin: 0 } },
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                        " [",
                        record.key,
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                        " [",
                        record.date_added2.format(_this.props.state.getDateTimeFormat()),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                        " [",
                        record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                        "]")); } })));
    };
    return AffilateBrandsList;
}(React.Component));
exports.default = AffilateBrandsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/component/config/brands/AffilateBrandsList.tsx
// module id = 2020
// module chunks = 0